import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';

/**
 * Configuración de locales para la aplicación
 * Registra los locales disponibles para su uso en datepickers, pipes de fecha, etc.
 */
export function configureLocales(): void {
  registerLocaleData(localeEs, 'es');
  registerLocaleData(localeEn, 'en');
}

